import { useEffect, type ReactNode } from 'react';
import { bootstrapAuth } from '../lib/api';
import { useStore } from '../lib/store';
import { LoginScreen } from './LoginScreen';

export function AuthGate({ children }: { children: ReactNode }): JSX.Element {
  const status = useStore((s) => s.authStatus);
  const setAuthStatus = useStore((s) => s.setAuthStatus);

  useEffect(() => {
    let cancelled = false;
    bootstrapAuth()
      .then((next) => {
        if (!cancelled) setAuthStatus(next);
      })
      .catch(() => {
        if (!cancelled) setAuthStatus('needs-login');
      });
    return () => {
      cancelled = true;
    };
  }, [setAuthStatus]);

  if (status === 'pending') {
    return (
      <div className="flex h-screen items-center justify-center bg-bg text-text-dim">
        <span className="animate-pulse font-display text-sm">Загрузка…</span>
      </div>
    );
  }

  if (status === 'needs-login') {
    return <LoginScreen />;
  }

  return <>{children}</>;
}
